import { DocumentNode, GraphQLError } from 'graphql';
import type { MockedResponse } from '@apollo/client/testing';

/**
 * @deprecated: Incorrectly typed. Please use createMockResponse instead.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mockSuccess = (query: any, variables: object, data: object) => [
  {
    request: {
      query,
      variables,
    },
    result: {
      data,
    },
  },
];

export interface CreateMockInput<Variables, Data> {
  query: DocumentNode;
  variables?: Variables;
  data?: Data;
  errors?: GraphQLError[];
  networkError?: Error;
  delay?: MockedResponse['delay'];
  maxUsageCount?: number;
}

export function createMockResponse<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Variables extends Record<string, any> | undefined,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Data extends Record<string, any> | null | undefined,
>({
  query,
  variables,
  data,
  errors,
  networkError,
  delay,
  // If maxUsageCount is omitted we allow unlimited uses. This prevents frequent
  // "No more mocked responses" warnings for read-only queries reused across many tests.
  // Provide an explicit number when you want to assert a query only fires a limited
  // number of times.
  maxUsageCount,
}: CreateMockInput<Variables, Data>): MockedResponse {
  if (networkError) {
    return {
      request: { query, variables },
      error: networkError,
      delay,
    };
  }

  return {
    request: { query, variables },
    result: { data, errors },
    delay,
    maxUsageCount: typeof maxUsageCount === 'number' ? maxUsageCount : Infinity,
  };
}
